import React from 'react';

import { IPrivateRouteProps } from '@domain/interfaces/routes/IRoute';

const PrivateRoute: React.FC<IPrivateRouteProps> = ({ component: Component, ...rest }) => {
  return <Component {...rest} />;
};

export default React.memo(PrivateRoute);
